import cx from 'classnames';
import { ReactNode } from 'react';
import Typography, { Variant } from '../Typography/index.js';

type ListStyleType = 'bullet' | 'number';

export interface BulletListProps {
  children: ReactNode;
  space?: boolean;
  variant?: Variant;
  type?: ListStyleType;
}

export function SimpleListItem({
  children,
  variant = 'body',
}: { children: ReactNode; variant?: Variant }): JSX.Element {
  return (
    <Typography variant={variant} tag="li">
      {children}
    </Typography>
  );
}

const SimpleList = ({ children, space, type = 'bullet' }: BulletListProps): JSX.Element => {
  const Component = type === 'number' ? 'ol' : 'ul';
  return (
    // TODO do better w/ space
    <Component
      className={cx('pl-6', {
        'space-y-4': space,
        'list-disc': type === 'bullet',
        'list-decimal': type === 'number',
      })}
    >
      {children}
    </Component>
  );
};

export default SimpleList;
